export default __webpack_public_path__ + "static/media/arrow_right.8e9d96a2.svg";